import {
  GET_SURVEY_REQUEST,
  SAVE_ANSWER_REQUEST,
  RESET_BLOCK_SURVEY,
} from '../reducers/SurveyReducer';

export const getSurveys = () => ({ type: GET_SURVEY_REQUEST });

export const answerQuestion = (payload) => ({
  type: SAVE_ANSWER_REQUEST,
  payload,
});

export const reset = (block) => ({ type: RESET_BLOCK_SURVEY, block });
